module.exports = __webpack_public_path__ + "img/cute_handdrawn_3.142523a6.png";